module.exports = __webpack_public_path__ + "static/media/flora1216-彩钢公寓开门方向.a8988d09.pdf";